import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useCognitoStore = defineStore('cognito', () => {
    const idToken = ref('');
    const getIdToken = computed(() => idToken.value);

    const accessToken = ref('');
    const getAccessToken = computed(() => accessToken.value);

    const authenticated = ref(false);
    const isAuthenticated = computed(() => authenticated.value);

    const clientGroup = ref('');
    const getClientGroup = computed(() => clientGroup.value);

    const timeout = ref('');

    function $reset() {
        idToken.value = '';
        accessToken.value = '';
        authenticated.value = false;
        clientGroup.value = '';
        timeout.value = '';
    }

    return { idToken, getIdToken, accessToken, getAccessToken, authenticated, isAuthenticated, clientGroup, getClientGroup, timeout, $reset }
}, { persist: true })
